module.exports = __webpack_public_path__ + "static/img/title.fa3bfdd9.png";